import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { track, ANALYTICS_EVENTS } from "../../../utils/productAnalytics";

const FinalCTASection: React.FC = () => {
  return (
    <section id="cta" className="py-24 md:py-40">
      <div className="max-w-[1200px] mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative rounded-[24px] overflow-hidden px-8 py-24 md:px-16 md:py-32 text-center"
          style={{
            background:
              "linear-gradient(135deg, #1e1a28 0%, #2c2536 40%, #231e2e 100%)",
          }}
        >
          {/* Subtle gradient accent */}
          <div
            className="absolute inset-0 opacity-30 pointer-events-none"
            style={{
              background:
                "radial-gradient(ellipse 60% 50% at 50% 100%, rgba(62,178,152,0.3) 0%, transparent 70%)",
            }}
          />

          <div className="relative">
            <h2 className="text-[40px] md:text-[72px] lg:text-[80px] font-extrabold text-white tracking-tight leading-[1.05]">
              広告制作を、
              <br />
              競争優位の源泉へ。
            </h2>
            <p className="mt-8 text-[18px] md:text-[20px] text-white/60 max-w-xl mx-auto">
              7日間無料トライアル。クレジットカード不要。
              月額9,800円から、広告バナーの量産を始められます。
            </p>

            <div className="mt-12 flex flex-wrap items-center justify-center gap-4">
              <Link
                to="/signup"
                onClick={() => track(ANALYTICS_EVENTS.CTA_CLICKED, { cta_id: "final_signup", location: "landing_final_cta" })}
                className="inline-flex items-center h-16 px-12 rounded-full bg-[#3eb298] text-[#1d1926] text-[18px] font-semibold hover:opacity-90 transition-opacity no-underline"
              >
                無料で試す
              </Link>
              <a
                href="#contact"
                className="inline-flex items-center h-16 px-12 rounded-full border border-white/20 text-white text-[18px] font-medium hover:bg-white/5 transition-colors no-underline"
              >
                お問い合わせ
              </a>
            </div>

            <div className="mt-8 flex items-center justify-center gap-8 text-[14px] text-white/40">
              <span>7日間無料</span>
              <span>クレカ不要</span>
              <span>即日利用開始</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTASection;
